var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: { propsData: { MultipleOptions: false } },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addadRevenue.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: _vm.sels.length == 0 },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(_vm.selsString)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchDelete")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              type: "selection",
              label: _vm.$t("idLabel"),
              width: "60"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "date", label: _vm.$t("date") }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_reveal", label: _vm.$t("game") }
          }),
          _c("el-table-column", {
            attrs: { prop: "platform_reveal", label: _vm.$t("platform") }
          }),
          _c("el-table-column", {
            attrs: { prop: "channel_reveal", label: _vm.$t("channel") }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg_reveal",
              label: _vm.$t("deliveryPackageLabel"),
              width: "260"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_channel_reveal", label: _vm.$t("adChannel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_placement_reveal", label: _vm.$t("adPlacement") }
          }),
          _c("el-table-column", {
            attrs: { prop: "country", label: _vm.$t("country") }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_income", label: _vm.$t("adIncomeCents") }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              fixed: "right",
              width: "160",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addadRevenue.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete([row.id])
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total
        },
        on: { "size-change": _vm.sizeChange, "current-change": _vm.searchClick }
      }),
      _c("addadRevenue", {
        ref: "addadRevenue",
        on: {
          refreshDataList: function($event) {
            return _vm.searchClick(_vm.searchClick.page, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }